import React from "react";
import { NikoPatientInsuranceEditTemplate } from "themes/application/niko-patient/components";
import { NikoPatientInsuranceEditViewStore } from 'application/niko-patient/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new NikoPatientInsuranceEditViewStore(rootStore, componentProps), 'nikoPatientInsuranceEditViewStore')
@observer
class NikoPatientInsuranceEdit extends React.Component {
	render() {
		return <NikoPatientInsuranceEditTemplate {...this.props} />;
	}
}

export default NikoPatientInsuranceEdit;